import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function displaySwitch(): ComponentStyle {
  return {
    componentName: 'displaySwitch',
    baseStyle: {
      position: 'relative',
      backgroundColor: 'transparent',
      gap: 0,
      borderRadius: 'unset',
      overflowY: 'auto',

      ['&:after']: {
        content: '""',
        position: 'absolute',
        inset: 0,
        zIndex: -1,
        mixBlendMode: 'overlay'
      }
    }
  };
}
